export default class Overlay {
  public show: boolean = false;
  public text: string = '';
  public color: string = '';

  constructor(
    text= '',
    show = false,
    color = 'black',
  ) {
  this.show = show;
  this.text = text;
  this.color = color;
  }
}
